import { $http } from '@/main';
import store from '@/store';

// When the request succeeds
const success = (response) => {
  store.dispatch('Locations/currentLocation', response);
};
const failure = (error) => {
  store.dispatch('Errors/error', error.data);
};


export default async (id) => {
  try {
    const response = await $http.delete(`/announcements/${id}`);
    success(response.data);
  } catch (error) {
    failure(error.response);
    throw error;
  }
};
